module.exports = __webpack_public_path__ + "img/cambridge-go-logo.71b80867.png";